import React from 'react';
import './MapView.scss';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { MarkerList } from './MarkerList';
import { SidePanel } from './SidePanel';
import { useDispatch, useSelector } from 'react-redux';
import Fab from '@mui/material/Fab';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { triggerMapReset } from '../../store/Actions';
import { Search } from '../header/filters/search/Search';
import { FilterButton } from '../header/buttons/FilterButton';
import { AddEventButton } from '../header/buttons/AddEventButton';
import { getMapOverlayTop, getSelectedEventPanelWidth, getSideNavWidth } from './mapLayout';

  const API_KEY = 'AIzaSyC0Fwcf-NgdobThTxJbi0fdfpMA_qY0dcs';

  const recenterFabStyle = {
    position: 'absolute',
    bottom: '20px',
    left: '20px',
    zIndex: 100,
  };

  export function MapView(props) {
    const appWidth = useSelector(state=>state.appWidth);
    const showResetView = useSelector(state=>state.showResetView);
    const embed = useSelector(state=>state.embed);
    const sideNavOpen = useSelector(state=>state.sideNavOpen);
    const dispatch = useDispatch();
    const selectedEvent = useSelector(state=>state.selectedEvent);
    const showMapControls = props.hideSidePanel !== true && !embed;
    const sideNavWidth = getSideNavWidth(appWidth);
    const selectedEventPanelWidth = getSelectedEventPanelWidth(appWidth, sideNavOpen);
    const leftOccupiedWidth = sideNavOpen ? sideNavWidth : 0;
    // The SelectedEventPanel only renders inside SidePanel, so it only
    // takes up space on the right when SidePanel is being shown. When the
    // parent hides the SidePanel (e.g. TimelineView), selecting an event
    // shouldn't push the Add Event button left.
    const rightOccupiedWidth = (selectedEvent && props.hideSidePanel !== true) ? selectedEventPanelWidth + 20 : 0;
    const availableMapWidth = appWidth - leftOccupiedWidth - rightOccupiedWidth;
    const controlsStyle = appWidth > 560
        ? {
            left: `${leftOccupiedWidth + (availableMapWidth / 2)}px`,
            top: getMapOverlayTop(appWidth)
        }
        : { top: getMapOverlayTop(appWidth) };

    // Add Event button lives at the top-right of the visible map area.
    // When the SelectedEventPanel is showing on the right, push the button
    // left of it so they don't overlap. On mobile we keep it pinned to the
    // right edge with a smaller gutter.
    const addEventButtonRight = appWidth <= 560
        ? 12
        : (rightOccupiedWidth > 0 ? rightOccupiedWidth + 8 : 20);
    const addEventButtonStyle = {
        position: 'absolute',
        top: getMapOverlayTop(appWidth),
        right: addEventButtonRight,
        zIndex: 110,
        width: appWidth <= 560 ? 40 : 48,
        height: appWidth <= 560 ? 40 : 48,
    };

    return (
        <div className="map-view">
            {props.hideSidePanel !== true &&
                <SidePanel/>
            }
            {showMapControls &&
                <div className="map-view__controls" style={controlsStyle}>
                    <Search/>
                    <FilterButton/>
                </div>
            }
            {!embed && props.hideAddEvent !== true &&
                <AddEventButton
                    variant="accent"
                    size="md"
                    shape="circle"
                    className="map-view__add-event-control"
                    style={addEventButtonStyle}
                    ariaLabel="Add Event"
                />
            }
            <APIProvider apiKey={API_KEY} libraries={['marker']}>
                <Map
                    mapId={'bf51a910020fa25a'}
                    defaultZoom={2}
                    defaultCenter={{lat: 16, lng: 0}}
                    gestureHandling={'greedy'}
                    disableDefaultUI={true}
                    zoomControl={false}
                    fullscreenControl={false}
                    cameraControl={false}
                    mapTypeControl={false}
                    streetViewControl={false}
                    keyboardShortcuts={false}
                >
                    <MarkerList eventsOverride={props.eventsOverride} onMarkerClick={props.onMarkerClick}/>
                </Map>
            </APIProvider>
            <Fab
                size="medium"
                color="default"
                aria-label="Reset map view"
                disabled={!showResetView}
                style={recenterFabStyle}
                onClick={()=>dispatch(triggerMapReset())}
            >
                <CenterFocusStrongIcon/>
            </Fab>
        </div>

    );
  }
  
